module.exports = __webpack_public_path__ + "static/media/project2.1cff5a20.jpg";